// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ServiceSettingsAreaId } from './ServiceSettingsAreaId'
import { ServiceSettingsAreaNavigation } from './ServiceSettingsAreaNavigation'
import { ServiceSettingsAreaRoutes } from './ServiceSettingsAreaRoutes'

const LazyServiceSettingsComponent = lazy(() => import('./ServiceSettingsArea'))

const ServiceSettingsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyServiceSettingsComponent />
  </SuspenseLoadingWrapper>
)

export const ServiceSettingsArea = {
  id: ServiceSettingsAreaId,
  requiredRight: BoumRight.AREA_SERVICE_SETTINGS,
  NavigationComponent: ServiceSettingsAreaNavigation,
  route: {
    path: ServiceSettingsAreaRoutes.route,
    component: ServiceSettingsComponent,
  },
}
